// extracted by mini-css-extract-plugin
export default {"context":"NotFound_context__k5pRo","area":"NotFound_area__MsPIH","circles":"NotFound_circles__HfbPW","animate":"NotFound_animate__8jnui"};